import axios from "axios";

const urlPath = "legalia";

export const getLegaliaOptions = async () => {
  try {
    const response = await axios.get("legalias");
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getRiesgos = async (aaffId) => {
  try {
    const response = await axios.get(`${urlPath}/riesgos`, {
      params: { aaff_id: aaffId },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getSenalizaciones = async (aaffId) => {
  try {
    const response = await axios.get(`${urlPath}/senalizaciones`, {
      params: { aaff_id: aaffId },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const enviarEmailComercial = async (asunto, contenido, senalizaciones) => {
  const datos = {
    asunto,
    contenido,
    senales: senalizaciones.map((item) => ({
      totalComunidades: item.totalComunidades,
      label: item.label,
    })),
  }
  const response = await axios.post(`${urlPath}/email-comercial`, datos);
  return response.data;
};

export const logContratacionModal = async (action) => {
  try {
    const response = await axios.post(`${urlPath}/log-contratacion-kae`, { action });
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
